import { Button, Form, FormInstance, Row, Upload } from "antd";
import { useCallback, useMemo } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { useDownload } from "../../../../pages/Administration/TemplatesTab/hooks/useDownload";
import { useUploadFile } from "../../../../lib/hooks/useUploadFile";
import { UserFilesService } from "../../../../services/userFiles";
import { useUploadFileRule } from "../../../../lib/hooks/useUploadFileRule";
import MailingsService from "../../../../services/mailings";

type LetterProps = {
  form: FormInstance;
  disabled: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  showBtn?: boolean;
};

export const Letter = ({
  form,
  disabled,
  setIsLoading,
  showBtn = false,
}: LetterProps) => {
  const { onDownload } = useDownload(
    disabled ? MailingsService : UserFilesService
  );

  const onDownlaodClick = useCallback(
    (file: any) => onDownload(file.response, file.name),
    [onDownload]
  );

  const templateId = Form.useWatch("templateId", form);

  const showUploadListProps = useMemo(
    () => ({ showDownloadIcon: true, showRemoveIcon: false }),
    []
  );

  const { upload } = useUploadFile(2, setIsLoading);

  const { rule } = useUploadFileRule();

  return (
    <Row className="position-relative">
      <Form.Item
        label={disabled || templateId ? "Letter" : ""}
        name="fileList"
        className="mb-2 w-100"
        valuePropName="fileList"
        getValueFromEvent={(e) => e.fileList}
        rules={rule}
      >
        <Upload
          listType="picture"
          customRequest={upload}
          previewFile={async () => ""}
          showUploadList={showUploadListProps}
          onDownload={onDownlaodClick}
          maxCount={1}
        >
          {(templateId || showBtn) && (
            <>
              <Button icon={<UploadOutlined />} shape="round">
                Replace File
              </Button>
              <span className="ml-2 text-sm title">
                Download, edit and replace the file to edit the letter
              </span>
            </>
          )}
        </Upload>
      </Form.Item>
    </Row>
  );
};
